class ProductUpsells extends HTMLElement {
    constructor() {
        super()

        this.sectionId = this.getAttribute("data-section-id");
    }

    connectedCallback() {
        this.setEventListeners()
    }

    setEventListeners() {
        this.addEventListener("click", async event => {
            const addButton = event.target instanceof Element ? event.target.closest('[js-product-upsells="add"]') : null;

            if (addButton && this.contains(addButton)) {
                this.handleAdd(addButton)
            }
        })
    }

    async handleAdd(target) {
        try {
            this.classList.toggle("is-loading", true)

            const variantId = target.dataset.variantId;

            const body = {
                items: [
                    {
                        id: Number(variantId),
                        quantity: 1
                    }
                ],
            }

            const crossSellModal = document.querySelector('.cross-sell-modal');
            if (crossSellModal) body.sections = 'cross-sell-modal';

            const addResponse = await fetch(window.Shopify.routes.root + "cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body)
            });

            if (!addResponse.ok) {
                throw new Error("Something went wrong")
            }

            const addData = await addResponse.json();

            if (addData.sections && addData.sections["cross-sell-modal"] && crossSellModal) {
                // Data for the cross-sell-modal to update itself
                crossSellModal.dispatchEvent(new CustomEvent("newItemForModal", { detail: { html: addData.sections["cross-sell-modal"] } }));
            }

            const response = await fetch(
                `${location.pathname}?sections=${this.sectionId}`
            ).then(res => res.json());

            const newMarkup = new DOMParser()
                .parseFromString(response[this.sectionId], "text/html")
                .querySelector(this.tagName.toLowerCase());

            if (!newMarkup) {
                return
            }

            //Updating cart count
            document.querySelectorAll("[js-cart-count]").forEach(element => {
                element.textContent = (Number(element.textContent) + 1).toString()
                element.classList.remove("is-hidden")
            })

            const newButton = newMarkup.querySelector(`button[data-variant-id='${variantId}']`);

            if (!newButton) { console.warn(`Can't find new btn HTML`); return; }

            //Update all buttons across all uwp-product-upsells
            const currentButtons = document.querySelectorAll(`uwp-product-upsells button[data-variant-id='${variantId}']`);

            currentButtons.forEach((button) => {
                button.innerHTML = newButton.innerHTML;
                button.classList.add("btn--primary-alt");
                button.classList.remove("btn--secondary");
                button.classList.remove("btn--primary");
            })
        } catch (error) {
            console.error(error)
        } finally {
            this.classList.toggle("is-loading", false)
        }
    }
}

customElements.define("uwp-product-upsells", ProductUpsells)
